export const RESET_AUTH_STATE = 'resteAuthState'
export const RESET_USER_STATE = 'resetUserState'
export const RESET_LIVE_STREAM_STATE = 'resetLiveStreamState'
export const RESET_COMMENT_STATE = 'resetCommentState'
export const RESET_NOTIFICATION_STATE = 'resestNotificationState'
export const RESET_CLUB_STATE = 'resetClubState'
export const RESET_SCHEDULE_STATE = 'resetScheduleState'
export const CHECK_AUTH = 'checkAuth'
export const LOGIN = 'login'
export const FORGET_PASSWORD = 'forgetPassword'
export const LOGOUT = 'logout'
export const UPDATE_USER = 'updateUser'
export const CREATE_LIVE_STREAM = 'createLiveStream'
export const UPDATE_LIVE_STREAM = 'updateLiveStream'
export const DELETE_LIVE_STREAM = 'deleteLiveStream'
export const CREATE_STREAMER = 'createStreamer'
export const GET_STREAMERS = 'getStreamers'
export const GET_ALL_STREAMERS = 'getAllStreamers'
export const GET_STREAMER = 'getStreamer'
export const UPDATE_STREAMER = 'updateStreamer'
export const GET_USERS = 'getUsers'
export const GET_BANNED_USERS = 'getBannedUsers'
export const GET_LIVE_STREAMS = 'getLiveStreams'
export const GET_CURRENT_LIVE_STREAMS = 'getCurrentLiveStreams'
export const GET_LIVE_STREAM = 'getLiveStream'
export const UPDATE_LIVE_STREAM_STATUS = 'updateLiveStreamStatus'
export const GET_WOWZA_STATUS = 'getWowzaStatus'
export const ADD_FAKE_VIEWERS = 'addFakeViewers'
export const GET_COMMENTS = 'getComments'
export const UPDATE_USER_STATUS = 'updateUserStatus'
export const PIN_COMMENT = 'pinComment'
export const CREATE_NOTIFICATION = 'createNotification'
export const GET_NOTIFICATIONS = 'GET_NOTIFICATIONS'
export const UPLOAD_FILE = 'uploadFile'
export const CREATE_POLL_QUESTION = 'createPollQuestion'
export const UPDATE_POLL_QUESTION = 'updatePollQuestion'
export const DELETE_POLL_QUESTION = 'deletePollQuestion'
export const GET_PROFILE = 'getProfile'
export const GET_DASHBOARD = 'getDashboard'
export const UPDATE_PROFILE = 'updateProfile'
export const CHANGE_PASSWORD = 'changePassword'
export const EXPORT_POLL = 'exportPoll'
export const RESET_PASSWORD = 'resetPassword'
export const CREATE_CLUB = 'createClub'
export const INVALID_CLUB_LOGO = 'invalidClubLogo'
export const GET_CLUBS = 'getClubs'
export const DELETE_CLUB = 'deleteClub'
export const GET_CLUB = 'getClub'
export const UPDATE_CLUB = 'updateClub'
export const CREATE_LIVE_SCHEDULE = 'createLiveSchedule'
export const GET_LIVE_SCHEDULES = 'getLiveSchedule'
export const DELETE_SCHEDULE = 'deleteSchedule'
export const GET_SCHEDULE = 'getSchedule'
export const UPDATE_SCHEDULE = 'updateSchedule'
export const UPLOAD_VIDEO = 'uploadVideo'
export const GET_VIDEOS = 'getVideos'
export const GET_VIDEO_STATUS = 'getVideoStatus'
export const CREATE_POST = 'createPost'
export const GET_POSTS = 'getPosts'
export const UPLOAD_POST_PHOTO = 'uploadPostPhoto'
export const GET_POST = 'getPost'
export const DELETE_POST = 'deletePost'
export const GET_POST_COMMENTS = 'getPostComments'
export const EDIT_POST = 'editPost'
export const CREATE_EDITOR = 'createEditor'
export const GET_USER = 'getUser'
export const INVALIDATE_STREAM = 'invalidateStream'
export const MODIFY_DB_CAPACITY = "modifyDbCapacity";
export const GET_DB_INFO = "getDbInfo";